import parse from 'utils/parse';
import happen from 'utils/happen';

const makeTestId = (...ids: string[]): string => parse.toTestId('landing', 'model-contest-banner', ...ids);

const testId = Object.freeze({
  component: makeTestId(),
  joinButton: makeTestId('join-button'),
});

const modelContestBannerStartDate = '2025-08-18T13:00:00+02:00';
const modelContestBannerEndDate = '2026-01-12T00:00:00+01:00';

// The date on the banner is requested to be hardcoded, not localized.
const modelContestStartDate = '2025-09-24T00:00:00Z';

const contestPrize = 1_000_000;

/**
 * Checks if the model contest banner is currently active based on the defined start and end dates
 * @returns boolean indicating if the banner is currently active
 */
const isModelContestBannerActive = (now = new Date()): boolean => {
  return happen(now).between(
    new Date(modelContestBannerStartDate).getTime(),
    new Date(modelContestBannerEndDate).getTime()
  );
};

export {
  modelContestBannerStartDate,
  modelContestBannerEndDate,
  modelContestStartDate,
  isModelContestBannerActive,
  contestPrize,
  testId,
};
